<template>
  <div id="landing-shops">
    
    <div class="main-banner-white">
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="text-wrapper">
            <div class="h1 font-weight-bolder">
              <div class="pt-2">Aumenta la tua visibilità e resta in contatto con i tuoi clienti.</div>
            </div>
            <b-button variant="dark" class="mt-2 text-white btn-style" to="/registrati">Registra la tua attività</b-button>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="centered-image">
            <img src="../assets/img/cover-bg-3.png" alt="first illustration" />
          </div>
        </div>
      </div>
    </div>

    <!-- SECTION 2 --->
    <div class="txt-color bg-green">
      <div class="container d-none d-sm-block">
        <div class="row pt-5 pb-5">
          <div class="col-8 text-left align-self-center">
            <div class="col-12 align-self-center">
              <div class="h1 font-weight-bolder">
                <div class="pt-2">Come funziona</div>
              </div>
              <div class="h4">
                <div class="pt-2">
                  E' possibile inserire sulla mappa la posizione
                  <br />della propria attività.
                </div>
              </div>
              <b-button class="mt-2 text-white btn-success btn-style" to="/come-funziona">Come funziona</b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="container d-block d-sm-none">
        <div class="row pt-5 pb-5">
          <div class="col-12 text-left align-self-center">
            <div class="h1 font-weight-bolder">Come funziona</div>
            <div class="h4">
              <div class="pt-2">
                E' possibile inserire sulla mappa la posizione
                <br />della propria attività.
              </div>
            </div>
            <b-button variant="dark" class="mt-2 text-white btn-style" to="/come-funziona">Come funziona</b-button>
          </div>
        </div>
      </div>
    </div>
    <!-- SECTION 3 -->
    <div>
      <div class="container d-none d-sm-block">
        <div class="row pt-5 pb-5">
          <div class="col-8 text-left align-self-center">
            <div class="h3">Vogliamo aiutare le aziende della nostra valle, noi ci crediamo. E tu?</div>
            <div class="row mt-4">
              <div class="col-4 mr-4 pr-0">
                <b-button variant="dark" class="text-white btn-style" to="/registrati">Registra la tua attività</b-button>
              </div>
              <div class="col-4 mr-4 pr-0">
                <b-button variant="success" class="btn-block btn-style" to="/mappa">Cerca un'attività</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container d-block d-sm-none">
        <div class="row pt-5 pb-5">
          <div class="col-12 text-left align-self-center">
            <div class="h3">Vogliamo aiutare le aziende della nostra valle, noi ci crediamo. E tu?</div>
          </div>
          <div class="col-12">
            <div class="row mt-4">
              <div class="col-6">
                <b-button variant="dark" class="text-white btn-style" to="/registrati">Registra la tua attività</b-button>
              </div>
              <div class="col-6">
                <b-button variant="success" class="btn-block btn-style" to="/mappa">Cerca un'attività'</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {};
</script>

<style scoped>
a,
a:visited,
a:hover {
  text-decoration: none;
}

#landing-shops {
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
